module.exports = __webpack_public_path__ + "img/gear.4499de6f.svg";